export default __webpack_public_path__ + "static/media/1.a6db1ade.png";